import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,
  CCard,
  CCardBody,
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CPagination,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm,
  CFormGroup,
  CFormText,
  CLabel,
  CInput,CInputGroup,CInputGroupText
} from 'compat/coreui'

import axios from 'axios';
import moment from 'moment';

const getBadge = status => {
  switch (status) {
    case 'Active': return 'success'
    case 'Inactive': return 'secondary'
    case 'Pending': return 'warning'
    case 'Banned': return 'danger'
    default: return 'primary'
  }
}

const Invoice = () => {
  const history = useNavigate()
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [categoryData, setCategoryData] = useState([]);


  const toggle = ()=>{
    setModal(!modal);
  }

  useEffect(async () => {
    getData()
  }, [])

  function getData() {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/invoice`,{
      headers: {
        'Authorization': 'Bearer '+localStorage.getItem('token')}
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }

  return (
    <CRow>
      <CCol xl={12}>
        <CCard>
          <CCardHeader className="category_header">
          Billing & Invoices
          </CCardHeader>
          <CCardBody>
            <div className="table-responsive"
            >
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>INVOICE#</th>
                    <th>NAME</th>
                    <th>DATE</th>
                    <th>STATUS</th>
                    <th>DUE</th>
                  </tr>
                </thead>
                  <tbody>
                    {categoryData.map((cat, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{cat.title}</td>
                            <td>{moment(cat.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                            <td>{cat.subTitle}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default Invoice;
